// Import required dependencies
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate('/Dashboard'); // Redirects to the home page or any other route you want
    };

    useEffect(() => {
        document.title = '404 Not Found'; // Set the title of the page
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                bgcolor: 'background.body',
                padding: 2,
            }}
        >
            <Typography level="h1" sx={{ mb: 2 }}>
                404
            </Typography>
            <Typography level="h4" sx={{ mb: 3 }}>
                Je n'ai pas trouvé cette page.
            </Typography>
            <Button
                variant="solid"
                color="primary"
                onClick={handleGoBack}
            >
                Retour à l'accueil
            </Button>
        </Box>
    );
};

export default NotFoundPage;
